import { Reveal } from "./Reveal";
import { APP_STORE_URL, PLAY_STORE_URL } from "../lib/links";

export const Footer = () => (
  <footer data-testid="footer" className="overflow-hidden bg-forest pt-20">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="grid grid-cols-1 gap-12 pb-20 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="font-syne text-2xl font-extrabold text-bone">
            Freshly<span className="text-fresh">.</span>
          </p>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-bone/60">
            Groceries in 20 minutes, not hours. Proudly built for Calgary&apos;s
            busiest people.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-app-store-link"
              className="rounded-full border border-bone/20 px-4 py-2 text-xs font-bold text-bone/80 transition-colors hover:border-fresh hover:text-fresh"
            >
              App Store
            </a>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-google-play-link"
              className="rounded-full border border-bone/20 px-4 py-2 text-xs font-bold text-bone/80 transition-colors hover:border-fresh hover:text-fresh"
            >
              Google Play
            </a>
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-fresh">
            Company
          </p>
          <ul className="mt-5 space-y-3 text-sm font-semibold text-bone/80">
            <li><a href="#sync" data-testid="footer-link-model" className="transition-colors hover:text-fresh">Our Model</a></li>
            <li><a href="#standard" data-testid="footer-link-standard" className="transition-colors hover:text-fresh">The Standard</a></li>
            <li><a href="#drive" data-testid="footer-link-careers" className="transition-colors hover:text-fresh">Careers</a></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-fresh">
            Contact
          </p>
          <ul className="mt-5 space-y-3 text-sm font-semibold text-bone/80">
            <li><a href="mailto:support@freshlydeliveries.click" data-testid="footer-link-email" className="transition-colors hover:text-fresh">support@freshlydeliveries.click</a></li>
            <li className="text-bone/70">Calgary, Alberta</li>
          </ul>
        </div>
      </div>
    </div>
    <Reveal y={60}>
      <p
        data-testid="footer-wordmark"
        className="select-none whitespace-nowrap text-center font-syne text-[clamp(5rem,17vw,17rem)] font-extrabold leading-[0.8] tracking-tighter text-bone/10"
      >
        FRESHLY
      </p>
    </Reveal>
    <div className="border-t border-bone/10 py-6">
      <p className="text-center text-xs font-semibold text-bone/40">
        © 2026 Freshly Inc. Fast, fresh, and stress-free.
      </p>
    </div>
  </footer>
);
